import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-completed-jobs')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/delivered"
    infiniteScroll={true}
    deliveredScreen={true}
    message_if_none = 'No jobs delivered yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-completed-jobs'));
}
